export default "__VITE_ASSET__BtHk55MO__"